import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useState,
} from 'react';
import { api } from '../server/api';

interface HistoricalInput {
  year: number;
  totalPoints: number;
}

interface PointsContextProps {
  redeemedPoints: number;
  totalPoints: number;
  availableToRedeem: number;
  pendingToRedeem: number;
  remainingPoints: number;
  historicalInputs: HistoricalInput[];
  setRemainingPoints: Dispatch<SetStateAction<number>>;
  getPoints: (clientUrl: string, playerId: string) => void;
}

interface PointsContextProviderProps {
  children: ReactNode;
}

export const pointsContext = createContext({} as PointsContextProps);

export function PointsContextProvider(props: PointsContextProviderProps) {
  const [remainingPoints, setRemainingPoints] = useState<number>();
  const [redeemedPoints, setRedeemedPoints] = useState<number>(0);
  const [totalPoints, settTotalPoints] = useState<number>(0);
  const [availableToRedeem, setAvailableToRedeem] = useState<number>(0);
  const [pendingToRedeem, setPendingToRedeem] = useState<number>(0);
  const [historicalInputs, setHistoricalInputs] = useState<HistoricalInput[]>(
    []
  );

  const getPoints = async (clientUrl: string, playerId: string) => {
    try {
      const response = await api.get(`/points/${clientUrl}/${playerId}`);
      if (response.data.error) {
        throw new Error();
      }
      setRedeemedPoints(response.data.body.redeemedPoints);
      settTotalPoints(response.data.body.totalPoints);
      setAvailableToRedeem(response.data.body.availableToRedeem);
      setPendingToRedeem(response.data.body.pendingToRedeem);
      setHistoricalInputs(response.data.body.historicalInputs ?? []);
    } catch (error) {
      console.log('getPointsProcessing error: ', error);
    }
  };

  return (
    <pointsContext.Provider
      value={{
        redeemedPoints,
        totalPoints,
        availableToRedeem,
        pendingToRedeem,
        remainingPoints,
        historicalInputs,
        getPoints,
        setRemainingPoints,
      }}
    >
      {props.children}
    </pointsContext.Provider>
  );
}
